import { apiInstance } from "./ApiInstance";

export const actionRequiredData = async (activeTab, payload) => {
  let { data = {} } = await apiInstance.get(
    `/api/case/action-required?year=${activeTab}`,
    payload
  );
  return data;
};
